import React from 'react';
import { Form, Select } from 'antd';
import Layout from './layout';

const FormItem = Form.Item;
const Option = Select.Option;

const getCourseLabel = (item, showLessonCount = false) => {
  const courseType = item.courseType || '';
  const courseName =
    item.courseName ||
    item.courseDisplayName ||
    (item.course && item.course.name) ||
    '';
  const feedbackCounter =
    typeof item.feedbackCounter === 'number' ? item.feedbackCounter : 0;
  const countText = `${feedbackCounter}次`;
  const courseTitle =
    courseType && courseName && courseType !== courseName
      ? `${courseType} ${courseName}`
      : courseName || courseType || '未命名课程';
  const countLabel = showLessonCount ? ` | ${countText}` : '';

  return item.enrollDate
    ? `${courseTitle}${countLabel} | ${item.enrollDate}`
    : `${courseTitle}${countLabel}`;
};

const EnrollCourseFormItem = (props) => {
  const {
    form,
    fetchEnrollCourseList,
    enrollCourseList = [],
    inputId,
    fetchEnrollCourseDetail,
    showLessonCount,
  } = props;

  const rules = props.rules
    ? props.rules
    : [{ required: true, message: '课程不能为空' }];

  const label = props.label ? props.label : '报名的课程';
  const selectedEnrollment = form.getFieldValue('enrollment');
  const hasSelectedOption =
    selectedEnrollment &&
    enrollCourseList.some((item) => item._id === selectedEnrollment);

  function receiveEnrollCourse(inputId) {
    const studentId = inputId || form.getFieldValue().student_id;
    if (studentId) {
      fetchEnrollCourseList(studentId);
    }
  }

  return (
    <FormItem label={label} {...Layout.formItemLayout} name='enrollment' rules={rules}>
      <Select
        mode='single'
        showSearch
        optionFilterProp='children'
        placeholder='请选择报名课程'
        filterOption={(input, option) =>
          String(option.children).toLowerCase().indexOf(input.toLowerCase()) >= 0
        }
        onFocus={() => receiveEnrollCourse(inputId)}
        onChange={(e) => {
          form.setFieldsValue({ enrollment: e });
          if (props.setIsTrigger) props.setIsTrigger(!props.isTrigger);
          if (fetchEnrollCourseDetail) fetchEnrollCourseDetail(e);
        }}
      >
        {selectedEnrollment && !hasSelectedOption && (
          <Option value={selectedEnrollment} key={selectedEnrollment} disabled>
            正在读取课程...
          </Option>
        )}
        {enrollCourseList.map((item) => (
          <Option value={item._id} key={item._id}>
            {getCourseLabel(item, showLessonCount)}
          </Option>
        ))}
      </Select>
    </FormItem>
  );
};

export default EnrollCourseFormItem;
